export const create = {
  createSuccessfully: 'Create new id card successfully!',
}
